import React from 'react';
import useI18n from 'i18n/useI18n';
import FloatingButton from '../../FloatingButton';
import FloatingRow from '../../FloatingRow';
import Family from './Family';
import Categories from './Categories';
import Subcategories from './Subcategories';
import Tags from './Tags';
import FormTitle from 'pages/MenuItems/components/FormTitle';

const Groups = ({ formData, submit, dispatch, next, title, isEdit = false }) => {
  const { translate } = useI18n();

  const onUpdate = (e) => {
    e.preventDefault();
    submit();
  }

  const onSubmit = (e) => {
    e.preventDefault();
    next();
  }
  
  return (
    <form style={{ width: '100%' }} onSubmit={onSubmit}>
      <FormTitle style={{ marginBottom: '20px', fontSize: '1.5rem' }}>{title}</FormTitle>
      <Family formData={formData} dispatch={dispatch} />
      <Categories formData={formData} dispatch={dispatch} />
      <Subcategories formData={formData} dispatch={dispatch} />
      <Tags formData={formData} dispatch={dispatch} />
      <FloatingRow>
        <FloatingButton isSecondary={true} type={'submit'}>{translate('Continue')}</FloatingButton>
        {isEdit && (<FloatingButton onClick={ onUpdate } >{translate('Update Item')}</FloatingButton>)}
      </FloatingRow>
    </form>
  );
};

export default Groups;